import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import SiteApp from './SiteApp';
import './site.css';

const container = document.getElementById('root');

if (!container) throw new Error('The page is missing its #root element.');

createRoot(container).render(
  <StrictMode>
    <SiteApp />
  </StrictMode>,
);
